export var REGION_TEXTS = {
  current: 'вы тут?',
  approve: 'да',
  change: 'поменять регион'
};